export function minutesToHours(minutes: number): number {
  return Math.floor(minutes / 60);
}

export function minutesToHoursAndMinutes(minutes: number): { hours: number; minutes: number } {
  const hours = Math.floor(minutes / 60);
  const minutesPart = minutes % 60;
  return { hours, minutes: minutesPart };
}

export function minutesToDecimalHours(minutes: number): number {
  return minutes / 60;
}
